import axios from 'axios'

const instance = axios.create({
  // baseURL: 'http://localhost:3000'
  baseURL: 'https://cms-admin-server-edi-yasa.herokuapp.com/'
})

export default instance
